if (!customElements.get('monties-swatch')) {
  customElements.define('monties-swatch', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.panels = [...this.querySelectorAll('.mv-swatch__panel')];
      this.triggers = this.panels.map(panel => panel.querySelector('summary'));
      if (!this.panels.length) return;
      this.activate(0);
      this.setAttribute('data-ready', '');
      this.triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', event => {
          event.preventDefault();
          this.activate(index);
        }, options);
        trigger.addEventListener('pointerenter', event => {
          if (this.dataset.hover !== 'true' || event.pointerType !== 'mouse' || !matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
          if (this.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) return;
          this.activate(index);
        }, options);
        trigger.addEventListener('keydown', event => {
          const horizontal = matchMedia('(min-width: 990px)').matches;
          const next = horizontal ? 'ArrowRight' : 'ArrowDown';
          const previous = horizontal ? 'ArrowLeft' : 'ArrowUp';
          let target;
          if (event.key === next) target = (index + 1) % this.panels.length;
          if (event.key === previous) target = (index - 1 + this.panels.length) % this.panels.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.panels.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          this.activate(target);
          this.triggers[target].focus();
        }, options);
      });
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.activate(index);
      }, options);
    }
    activate(index) {
      this.panels.forEach((panel, i) => { panel.open = i === index; });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
